import '../style.css';
import Menu from '../components/menu/Menu';
import ToTop from '../components/toTop/ToTop';
import PageTitle from '../components/pageTitle/PageTitle';
import CoverImage from '../assets/cover06.jpg'
import IntroEmpresa from '../components/introEmpresa/IntroEmpresa';
import NumerosEmpresa from '../components/numerosEmpresa/NumerosEmpresa';
import ContactoProduto from '../components/contactoProduto/ContactoProduto';
import Footer from '../components/footer/Footer';

function Servicos() {
  return (
    <>
        <Menu />
        <PageTitle title="Serviços" image={CoverImage} text="Encontre todas as nossas soluções." />
        <IntroEmpresa />
        <NumerosEmpresa />
        <ContactoProduto />
        <Footer />
        <ToTop />
    </>
  );
}

export default Servicos;